/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { HashLink as Link } from 'react-router-hash-link';
class Header extends Component {

  navToggle() {
    let elm = document.getElementsByClassName("homeNav")[0];
    let style = window.getComputedStyle(elm);
    if (Number(style.right.replace("px", '')) === 0) {
      elm.setAttribute("style", "right:-100%");
    } else {
      elm.setAttribute("style", "right:0");
    }
  }

  render() {
    let openLink = "/FundSpec/OpenAcct/";
    return <header className="mainHeader">
      <div className="anueContainer">
        <a href="https://www.anuefund.com/" target="_blank" rel="noopener noreferrer">
          <div className="logo" />
        </a>
        <nav className="homeNav">
          <ul className="BergerMenu">
            <li><Link to="/#pageTop" onClick={() => { this.navToggle() }} ><span>首頁</span></Link></li>
            <li><Link to="/#calculate" onClick={() => { this.navToggle() }}><span>親子理財試算</span></Link></li>
            <li><Link to="/#invest" onClick={() => { this.navToggle() }}><span>投資組合</span></Link></li>
            <li><Link to="/HouseView" onClick={() => { this.navToggle() }}><span>專家觀點</span></Link></li>
            <li><Link to="/#rules" onClick={() => { this.navToggle() }}><span>活動辦法</span></Link></li>
            <li><Link to="/#faq" onClick={() => { this.navToggle() }}><span>常見問題</span></Link></li>
            <li className="openAccount"><Link onClick={() => { this.navToggle(); }} style={{ backgroundColor: "#FF9901" }} to="/Login" target="_self"><span style={{ color: "white" }}> ▶ 交易登入</span></Link></li>
            <li className="openAccount"><a style={{ backgroundColor: "#FF0000" }} href={openLink} rel="noopener noreferrer" target="_blank"><span style={{ color: "white" }}> ▶ 立即開戶</span></a></li>
          </ul>
        </nav>
        <button className="toggle_nav" onClick={() => { this.navToggle(); }} style={{ backgroundColor: "transparent", border: "none" }}><span className="top"></span><span className="middle"></span><span className="bottom"></span></button>
      </div>
    </header>;
  }
}
export default withRouter(Header);